import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.perl = bracketIndenting({ line: "#" })
